<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #dbeafe; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #2563eb; font-size: 24px; width: 24px; height: 24px;">info</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Detalle de Transacci&oacute;n</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Informaci&oacute;n completa del movimiento VES</p>
    </div>
  </div>

  <!-- Info card -->
  <div style="margin: 16px 24px; padding: 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID Transacci&oacute;n</span>
        <span style="color: #2563eb; font-weight: 700; font-size: 0.9rem; font-family: monospace;">#{{ transaction.id }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Referencia</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ transaction.referenceId || '-' }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario (ID)</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ transaction.userName }} <span style="color: #6b7280; font-size: 0.75rem;">({{ transaction.userId }})</span></span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Email</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.userEmail }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Documento</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ transaction.userIdType }} {{ transaction.userIdNumber }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Pa&iacute;s / Nacionalidad</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.userCountry }} / {{ transaction.userNationality }}</span>
      </div>

      <!-- Empresa -->
      <div *ngIf="transaction.isCompany" style="grid-column: 1 / -1;">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Empresa</span>
        <span style="color: #2563eb; font-weight: 600; font-size: 0.85rem;">{{ transaction.companyName }} <span *ngIf="transaction.companyRut" style="color: #6b7280;">· {{ transaction.companyRut }}</span></span>
      </div>

      <!-- Tipo y estado -->
      <div style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <div class="flex flex-wrap gap-6">
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tipo</span>
            <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ getTypeLabel(transaction.type) }}</span>
          </div>
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Estado</span>
            <span style="font-weight: 700; font-size: 0.9rem; padding: 2px 10px; border-radius: 20px;"
              [style.color]="getStatusColor(transaction.status)"
              [style.background]="getStatusColor(transaction.status) + '15'">
              {{ transaction.status }}
            </span>
          </div>
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha <span style="color: #9ca3af; font-size: 0.65rem;">(hora Caracas)</span></span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ formatDate(transaction.createdAt) }}</span>
          </div>
        </div>
      </div>

      <!-- USDT info -->
      <div *ngIf="transaction.usdtAmount" style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <div class="flex flex-wrap gap-6">
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto USDT</span>
            <span style="color: #2563eb; font-weight: 700; font-size: 1rem;">{{ transaction.usdtAmount }} USDT</span>
          </div>
          <div *ngIf="transaction.vesRate">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tasa VES/USDT</span>
            <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ transaction.vesRate }}</span>
          </div>
        </div>
      </div>

      <!-- Banco / Operador -->
      <div *ngIf="transaction.banco || transaction.operador" style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <div class="flex flex-wrap gap-6">
          <div *ngIf="transaction.banco">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.banco }}</span>
          </div>
          <div *ngIf="transaction.operador">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Operador</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.operador }}</span>
          </div>
          <div *ngIf="transaction.operatorEmail">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Email Operador</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.operatorEmail }}</span>
          </div>
        </div>
      </div>

      <!-- Wallet retiro USDT -->
      <div *ngIf="transaction.walletAddress" style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <div class="flex flex-wrap gap-6">
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Red</span>
            <span style="color: #111827; font-weight: 600; font-size: 0.85rem;">{{ transaction.networkBinance }}</span>
          </div>
          <div style="flex: 1; min-width: 200px;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Wallet Address</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.8rem; font-family: monospace; word-break: break-all;">{{ transaction.walletAddress }}</span>
          </div>
          <div *ngIf="transaction.withdrawalFee">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fee</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.withdrawalFee }} USDT</span>
          </div>
          <div *ngIf="transaction.withdrawalStatus">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Estado Retiro</span>
            <span style="color: #111827; font-weight: 600; font-size: 0.85rem;">{{ transaction.withdrawalStatus }}</span>
          </div>
          <div *ngIf="transaction.binanceTxId" style="flex: 1; min-width: 200px;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Binance TxID</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.8rem; font-family: monospace; word-break: break-all;">{{ transaction.binanceTxId }}</span>
          </div>
        </div>
      </div>

      <!-- Descripción -->
      <div *ngIf="transaction.description" style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Descripci&oacute;n</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.description }}</span>
      </div>

      <!-- Montos VES -->
      <div style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <div class="flex flex-wrap gap-6">
          <div *ngIf="transaction.creditVes">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cr&eacute;dito VES</span>
            <span style="color: #16a34a; font-weight: 700; font-size: 1.1rem;">{{ formatVES(transaction.creditVes) }}</span>
          </div>
          <div *ngIf="transaction.debitVes">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">D&eacute;bito VES</span>
            <span style="color: #dc2626; font-weight: 700; font-size: 1.1rem;">{{ formatVES(transaction.debitVes) }}</span>
          </div>
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Saldo VES</span>
            <span style="color: #1e5a3f; font-weight: 700; font-size: 1.1rem;">{{ formatVES(transaction.balanceVes) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Button -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      Cerrar
    </button>
  </div>

</div>
